import React from "react";
import Select from "react-select";
import regionsAndCities from "@/utils/regionAndCities";

const DropdownWithCustomDesign = ({
  placeholder,
  onSelectRegion,
  onSelectCity,
  selectedRegion,
  selectedCity,
  isDisabled = false,
  // fieldLook: looks like the other fields of the popups (same height, inset shadow, grey text, small arrow)
  // instead of the plain white select of the older forms.
  fieldLook = false,
  defaultStyles = {
    backgroundColor: "#f1fffe",
    border: "1px solid #d4d4d4"
  }
}) => {
  const flattenedOptions = Object.keys(regionsAndCities)
    .flatMap((region) =>
      regionsAndCities[region].map((city) => ({
        label: city,
        value: city,
        region,
      }))
    )
    .sort((a, b) => a.label.localeCompare(b.label, "sl"));

  const handleChange = (selected) => {
    if (selected) {
      const selectedRegion = selected.region;
      const selectedCity = selected.value;

      if (onSelectRegion) {
        onSelectRegion(selectedRegion);
      }
      if (onSelectCity) {
        onSelectCity(selectedCity);
      }
    } else {
      if (onSelectRegion) {
        onSelectRegion(null);
      }
      if (onSelectCity) {
        onSelectCity(null);
      }
    }
  };

  return (
    <div className="w-full mx-auto">
      <Select
        options={flattenedOptions} // Use flattened options without grouping
        onChange={handleChange}
        value={
          selectedCity
            ? flattenedOptions.find((option) => option.value === selectedCity)
            : null
        }
        placeholder={placeholder || ""}
        isSearchable
        filterOption={(option, inputValue) => {
          if (!inputValue) return true;
          return option.label.toLowerCase().startsWith(inputValue.toLowerCase());
        }}
        isDisabled={isDisabled}
        styles={{
          control: (base) => ({
            ...base,
            ...defaultStyles, // Light gray border
            boxShadow: "none", // Remove default shadow
            borderRadius: "4px",
            "&:hover": { borderColor: "#105ccf" }, // Change border on hover
            minHeight: "36px", // Match the dropdown height in the image
            ...(fieldLook ?
              {
                backgroundColor: "#F2F8FF66",
                border: "none",
                borderRadius: "6px",
                minHeight: "40px",
                height: "40px",
                marginTop: "4px",
                paddingLeft: "11px",
                boxShadow:
                  "inset 3px 3px 5px rgba(166, 171, 189, 1), inset -3px -3px 3px rgba(250, 251, 255, 0.46)",
                "&:hover": { border: "none" },
              }
            : {}),
          }),
          dropdownIndicator: (base) => ({
            ...base,
            color: "#7d7d7d", // Arrow color
            "&:hover": { color: "#808080" }, // Arrow hover color
          }),
          indicatorSeparator: () => ({
            display: "none", // Remove the separator line
          }),
          menu: (base) => ({
            ...base,
            borderRadius: "4px", // Rounded menu
            marginTop: "2px", // Minimal gap
            zIndex: 10,
          }),
          option: (base, { isFocused }) => ({
            ...base,
            backgroundColor: isFocused ? "#e8f5f4" : "#fff", // Highlight on hover
            color: "#333", // Text color
            cursor: "pointer",
            fontSize: "14px", // Match other fields in popup
          }),
          input: (base) => ({
            ...base,
            fontSize: "14px", // Match other fields in popup
          }),
          placeholder: (base) => ({
            ...base,
            fontSize: fieldLook ? "15px" : "14px", // Match other fields in popup
            ...(fieldLook ? { color: "#6D778E" } : {}),
          }),
          singleValue: (base) => ({
            ...base,
            color: fieldLook ? "#1E2125" : "#105CCF",
            fontSize: fieldLook ? "15px" : "14px", // Match other fields in popup
          }),
        }}
      />
    </div>
  );
};

export default DropdownWithCustomDesign;
